<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-5">
    <div style="max-width:680px">
      <h3 class="mb-1">Viva Miljø Config</h3>
      <div style="font-style: italic; color:var(--bo-muted)">
        <strong>Global</strong> Viva Smart Checkout-plattformkonfig (gjelder alle merchants). De 5 endepunkt-URL-ene
        skiller kun mellom <strong>Sandbox</strong> og <strong>Produksjon</strong> — velg miljø, så avledes URL-ene
        i koden. Endringer tas i bruk uten restart.
      </div>
      <div class="alert alert-secondary mt-2 py-2" style="font-size:0.84rem">
        NB: dette er ikke den samme siden som <code>/viva</code> (merchantens egen Viva-konto per avdeling).
        Her styres bare hvilket Viva-miljø hele plattformen snakker med.
      </div>

      <config-lock ref="lock" :configured="isConfigured">
      <div class="mt-4">
        <label class="form-label mb-2 fw-semibold">Miljø</label>
        <div class="d-flex gap-3 flex-wrap">
          <label class="env-card" :class="{ 'env-selected': form.environment === 'SANDBOX' }">
            <input type="radio" value="SANDBOX" v-model="form.environment" />
            <span class="env-title">Sandbox / DEMO</span>
            <span class="env-sub">demo-*.vivapayments.com — for testing</span>
          </label>
          <label class="env-card" :class="{ 'env-selected': form.environment === 'PROD' }">
            <input type="radio" value="PROD" v-model="form.environment" />
            <span class="env-title">Produksjon</span>
            <span class="env-sub">vivapayments.com — ekte betalinger</span>
          </label>
        </div>
      </div>

      <div class="mt-4 d-flex align-items-center gap-3">
        <button class="bo_btn" @click="save" :disabled="saving">{{ saving ? 'Lagrer…' : 'Lagre' }}</button>
        <span v-if="message" :class="error ? 'text-danger' : 'text-success'">{{ message }}</span>
      </div>
      </config-lock>

      <div class="mt-4">
        <div class="fw-semibold mb-1" style="font-size:0.9rem">Avledede URL-er ({{ config.environment }})</div>
        <table class="table table-sm url-preview">
          <tbody>
            <tr><td>access token</td><td><code>{{ config.accessTokenUrl }}</code></td></tr>
            <tr><td>create order</td><td><code>{{ config.createPaymentOrderUrl }}</code></td></tr>
            <tr><td>get transaction</td><td><code>{{ config.getTransactionUrl }}</code></td></tr>
            <tr><td>checkout</td><td><code>{{ config.checkoutUrl }}</code></td></tr>
            <tr><td>refund</td><td><code>{{ config.refundUrl }}</code></td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfigLock from "@/components/other/ConfigLock";
import SettingsService from "@/services/settings/SettingsService";

export default {
  name: "VivaConfig",
  components: { LoadingSpinner, ConfigLock },
  computed: {
    // Already configured (→ starts locked): the server returned a saved environment (a fresh/empty
    // config has no `environment`, so it stays editable).
    isConfigured() { return !!this.config.environment; }
  },
  data() {
    return {
      loading: true,
      config: {},
      form: { environment: "SANDBOX" },
      saving: false,
      message: "",
      error: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      SettingsService.getVivaConfig().then(
        (response) => {
          this.config = response.data || {};
          this.form.environment = this.config.environment || "SANDBOX";
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke hente konfigurasjon.");
        }
      );
    },
    save() {
      this.saving = true;
      this.message = "";
      this.error = false;
      SettingsService.saveVivaConfig({
        environment: this.form.environment
      }).then(
        (response) => {
          this.saving = false;
          this.config = response.data || {};
          this.error = false;
          this.message = "Lagret ✓ — tas i bruk umiddelbart (ingen restart).";
          this.$refs.lock.relock();   // re-lock after a successful save
        },
        (error) => {
          this.saving = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke lagre konfigurasjon.");
        }
      );
    },
    errMsg(error, fallback) {
      const data = error && error.response ? error.response.data : null;
      return (data && data.error) || fallback;
    }
  }
};
</script>

<style scoped>
.env-card {
  flex: 1 1 240px;
  border: 1px solid var(--bo-line);
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.env-card input {
  margin-bottom: 0.35rem;
}
.env-selected {
  border-color: #ECB109;
  background: var(--bo-brand-tint);
  box-shadow: 0 0 0 1px #ECB109 inset;
}
.env-title {
  font-weight: 600;
}
.env-sub {
  font-size: 0.78rem;
  color: var(--bo-muted);
}
.url-preview td {
  font-size: 0.82rem;
  vertical-align: middle;
}
.url-preview td:first-child {
  color: var(--bo-muted);
  white-space: nowrap;
  width: 1%;
  padding-right: 1rem;
}
</style>
